import React, { MouseEventHandler } from 'react';
import styles from './HeaderMenu.scss';
import EllipsesMenu from '../../icons/dist/components/ellipsesMenu';
import _get from 'lodash/get';
import {
  headerTextColorOrDefault,
  messagesFontFamily,
  primaryColorOrDefault,
  theme,
} from '../../reducers';
import { connect } from 'react-redux';
import * as biLogger from '../../services/biLogger';
import { ChatroomDisplayData } from '../Widgets/SocialChat/SocialChat';
import utils from '../../services/utils';
import { InjectedTranslateProps, translate } from 'react-i18next';
import { withLockedTranslation } from '../../hoc/locked-translation';

export interface MenuItem {
  title: string;
  action: MouseEventHandler;
}

export interface HeaderMenuProps extends InjectedTranslateProps {
  menuItems: MenuItem[];
  primaryColor: string;
  headerTextColor: string;
  currentChatroom: ChatroomDisplayData;
  visitorId: string;
  messageFont: string;
}

interface HeaderMenuState {
  headerMenuExpand: boolean;
}

class _HeaderMenu extends React.Component<HeaderMenuProps, HeaderMenuState> {
  constructor(props: HeaderMenuProps) {
    super(props);
    this.state = {
      headerMenuExpand: false,
    };
  }

  handleMenuItemClicked = (
    event,
    onMenuItemClickedFunction: MouseEventHandler,
    menuItemText: string,
  ) => {
    const { currentChatroom, visitorId } = this.props;
    biLogger
      .forGroupChat(currentChatroom, visitorId)
      .groupChatMenuSelected(menuItemText);

    event.stopPropagation();
    this.setState({ headerMenuExpand: false });
    return onMenuItemClickedFunction(event);
  };

  handleMenuButtonClicked = (event) => {
    const { headerMenuExpand } = this.state;
    const { currentChatroom, visitorId } = this.props;

    event.stopPropagation();
    biLogger.forGroupChat(currentChatroom, visitorId).groupChatMenuClicked();
    this.setState({ headerMenuExpand: !headerMenuExpand });
  };

  render() {
    const {
      menuItems,
      primaryColor,
      headerTextColor,
      messageFont,
      t,
    } = this.props;
    const { headerMenuExpand } = this.state;

    const backgroundHeaderColor = _get(
      theme,
      'header.background',
      primaryColor,
    );

    const textHeaderColor = _get(theme, 'header.textColor', headerTextColor);

    const menuItemHoverOpacity = 0.2;
    const menuItemHoverBackground = utils.getRgbA(
      backgroundHeaderColor,
      menuItemHoverOpacity,
    );

    return (
      <div className={styles.wrapper} data-hook={'header-menu'}>
        <div className={styles.headerCollapsed}>
          <button
            data-hook={'menu-button'}
            className={`${styles.headerButton}`}
            onClick={this.handleMenuButtonClicked}
            style={{ color: `${textHeaderColor}` }}
            aria-label={t('header.menu.button.aria-label')}
          >
            <EllipsesMenu size={'24px'} />
          </button>
        </div>
        {headerMenuExpand && (
          <div data-hook={'menu-expand'} className={styles.headerExpandWrapper}>
            <div className={styles.headerExpand}>
              <div className={styles.headerExpandSpacer}></div>
              <div
                style={{
                  backgroundColor: `${menuItemHoverBackground}`,
                  fontFamily: messageFont,
                }}
                className={styles.headerExpandBackgroundForHover}
              >
                {menuItems.map((menuItem, index) => {
                  return (
                    <button
                      style={{ fontFamily: messageFont }}
                      key={`INDEX${index}`}
                      data-hook={'menu-item'}
                      className={`${styles.headerExpandButton}`}
                      onClick={(e) =>
                        this.handleMenuItemClicked(
                          e,
                          menuItem.action,
                          menuItem.title,
                        )
                      }
                    >
                      {menuItem.title}
                    </button>
                  );
                })}
              </div>
              <div className={styles.headerExpandSpacer}></div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  primaryColor: primaryColorOrDefault(state),
  headerTextColor: headerTextColorOrDefault(state),
  currentChatroom: state.currentChatroom,
  visitorId: state.chatInitResult.visitorId,
  messageFont: messagesFontFamily(state),
});

export const HeaderMenu = withLockedTranslation(
  translate()(connect(mapStateToProps)(_HeaderMenu)),
);
export default HeaderMenu;
